export const ContentTypes = {
  MULTIPART_FORM_DATA: "multipart/form-data",
  APPLICATION_JSON: "application/json"
};
